import gql from 'graphql-tag';

export const mutationSendAccountSlugEmail = gql`
  mutation sendAccountSlugEmail (
    $email: String!
  ) {
    sendAccountSlugEmail (
      email: $email
    )
  }
`;
export default mutationSendAccountSlugEmail;
